export const MEN_API_BASE_URL = process.env.REACT_APP_MEN_API_BASE_URL;
export const MEN_IDENTITY_BASE_URL = process.env.REACT_APP_MEN_IDENTITY_BASE_URL;
export const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CHANGE_APP_URL = process.env.REACT_APP_CHANGE_APP_URL;
export const MEN_PORTAL_WEB_BASE_URL = process.env.REACT_APP_MEN_PORTAL_WEB_BASE_URL;
export const MEN_PORTAL_WEB_BASE_PATH = process.env.REACT_APP_MEN_PORTAL_WEB_BASE_PATH;
export const MEN_PORTAL_API_BASE_URL = process.env.REACT_APP_MEN_PORTAL_API_BASE_URL;
